import { render } from "./EditTextbook.vue?vue&type=template&id=a8393122&scoped=true"
import script from "./EditTextbook.vue?vue&type=script&lang=js"
export * from "./EditTextbook.vue?vue&type=script&lang=js"

import "./EditTextbook.vue?vue&type=style&index=0&id=a8393122&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8393122"]])

export default __exports__